import React from "react"
import Header from "../../../components/Header"
import HeroSecondary from "../../../components/inner-page/HeroSecondary"
import Layout from "../../../components/Layout"
import FeatureCards from "../../../components/inner-page/FeatureCards"
import MainFeaturesSectionSecondary from "../../../components/inner-page/MainFeaturesSectionSecondary"
import EventTypes from "../../../components/inner-page/EventTypes"
import CustomerFeedback from "../../../components/inner-page/CustomerFeedback"
import TrustedBy from "../../../components/inner-page/TrustedBy"
import MagicWithUs from "../../../components/inner-page/MagicWithUs"

export function Index() {
  return (
    <Layout
      title="AI Conference Platform - Transform Event Networking"
      description="Power your conferences with AI photo sharing & networking. Turn attendees into advocates with intelligent engagement tools."
      keywords={[
        "AI conference platform, conference photo sharing, event networking technology, conference engagement tools, academic conference platform, tech conference solutions, corporate conference AI, conference attendee engagement, professional conference tools, conference management platform, networking conference technology, conference ROI platform, digital conference solutions, conference marketing tools, intelligent conference platform",
      ]}
    >
      <Header />
      <HeroSecondary />
      <FeatureCards />
      <MainFeaturesSectionSecondary />
      <TrustedBy />
      <CustomerFeedback />
      <EventTypes />
      <MagicWithUs />
    </Layout>
  )
}

export default Index
